var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"m-card"},[(_vm.hasHeader())?_c('header',[_vm._t("header",function(){return [_vm._v("Header")]})],2):_vm._e(),_c('main',[_vm._t("default",function(){return [_vm._v("Main")]})],2),(_vm.hasFooter())?_c('footer',[_vm._t("footer",function(){return [_vm._v("Footer")]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }